
import profile from './profile'
import documents from './documents'

const routes = [
  {
    path: '/',
    component: () => import('@/views/Home.vue'),
    meta: {
      auth: true
    },
    children: [
      {
        path: '/',
        name: 'home',
        component: () => import('@/views/Dashboard.vue'),
        meta: { gtm: 'home' }
      },
      {
        path: '/profile',
        name: 'profile',
        redirect: '/profile/me',
        component: () => import('@/views/Profile.vue'),
        meta: { gtm: 'profile' },
        children: [...profile]
      },
      ...documents
    ]
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/Login.vue'),
    meta: { gtm: 'login' }
  },
  {
    path: '/forgot-password',
    name: 'forgot-password',
    component: () => import('@/views/ForgotPassword.vue'),
    meta: { gtm: 'forgot-password' }
  },
  {
    path: '/change-password',
    name: 'change-password',
    component: () => import('@/views/ChangePassword.vue'),
    meta: { gtm: 'change-password' }
  },
  {
    path: '/reset-password/:token',
    props: true,
    name: 'reset-password',
    component: () => import('@/views/ResetPassword.vue'),
    meta: { gtm: 'reset-password' }
  },
  {
    path: '/update-password',
    name: 'update-password',
    component: () => import('@/views/UpdatePassword.vue'),
    meta: { gtm: 'update-password', auth: true }
  },
  {
    path: '*',
    name: 'errorPage',
    component: () => import('@/views/Error404.vue'),
    meta: { gtm: 'home' }
  },
  {
    path: '/unauthorized',
    name: 'unauthorized',
    component: () => import('@/views/Unauthorized.vue'),
    meta: { gtm: 'unauthorized', auth: true }
  },
  {
    path: '/register',
    name: 'register',
    component: () => import('@/views/Register.vue'),
    meta: { gtm: 'register' }
  }
]
export default routes
